import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { grey } from '@mui/material/colors';
import { ThemeProvider, createTheme } from '@mui/material';

const DEFAULT_SIZE = 40;
const DEFAULT_COLOR = grey[200];
const DEFAULT_MR = 4;

interface Props {
  size?: number
  color?: string
  mr?: number
}

const getMaterialTheme = (color: string) => createTheme({
  components: {
    MuiCircularProgress: {
      styleOverrides: {
        svg: {
          color: color || grey[200],
        },
      },
    },
  },
});

export function Loader(props: Props) {
  const { size = DEFAULT_SIZE, color = DEFAULT_COLOR, mr = DEFAULT_MR } = props;

  return (
    <ThemeProvider theme={getMaterialTheme(color)}>
      <CircularProgress style={{ height: size, width: size, marginRight: mr }} />
    </ThemeProvider>
  );
}
